import React, { useState, useRef, useEffect } from "react";

import {
    Box,
    Divider,
    TextField,
    Grid,
    Typography,
    Button,
    IconButton,
    InputAdornment,
    Container,
    Card,
    styled,
    FormHelperText,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    ListItemButton,
    List,
    ButtonGroup,
    ListSubheader,
    ListItem,
    ListItemText,
    Chip,
    Tooltip,
    Paper,
    Badge,
    FormControlLabel,
    Checkbox,
    FormGroup,
} from '@mui/material';

import { orange, grey } from "@mui/material/colors";

import dayjs from "dayjs";

import {
    LoadingButton
} from '@mui/lab';

import { useNavigate, useSearchParams, useParams } from 'react-router-dom';

import { useFormik } from 'formik';

import { useAppContextFeatures } from "../../../context/AppContext";
import { useAuthAccess } from "../../../hooks/useAuthAccess";

import CommonSectionHeader from "../../common/CommonSectionHeader";
import CommonBreadcumbs from '../../common/CommonBreadcumbs';
import CommonRestricted from "../../common/CommonRestricted";
import DatePickerComponent from "../../common/DatePickerComponent";
import { CommonIcons, icons } from "../../common/CommonIcons";
import LocationSelector from "../../selector/LocationSelector"

import SearchItems from "../../dialog/SearchItems";
// import SearchDocuments from "../../dialog/SearchDocuments";

import { useSystemPrompt } from "../../../hooks/useSystemPrompt";
import { useSystemRoutes, routeTypes } from "../../../hooks/useSystemRoutes";
import { useSystemHead, headTitles } from '../../../hooks/useSystemHead';
import { useItems, itemTypes } from "../../../hooks/api/useItems";
import { useDependencies, dependencyModules, dependencyTypes, targetTypes as dependencyTargetTypes } from "../../../hooks/api/useDependencies";

import { useDocuments, documentTypes, targetTypes } from "../../../hooks/api/useDocuments";
import { usePermissions, scopeIds, scopeTypes, functionTypes } from "../../../hooks/usePermissions";
import { useLocations, locationTypes, targetTypes as locationTargetTypes } from "../../../hooks/api/useLocations";
import { rackTypes, validationSchema, initialValues, initialRowValues } from "../../../schema/documents/itemRelocateSchema";

import { useStateInventoryBatches } from "../../../hooks/state/useStateInventoryBatches";
import { useTranslations } from '../../../hooks/useTranslations';

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(2)
}));

export const StyledIcon = styled(Box)({
    width: 20,
    height: 20,
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
});

export default function UpdateItemRelocate({
    routeType
}) {
    const { t } = useTranslations({ ns: ["common", "@document"] })

    const { id } = useParams();

    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()

    const { getAvailableLocations } = useAuthAccess();
    const { getLocationIds, setLocationIds } = useAppContextFeatures();

    const { promptMessage } = useSystemPrompt();
    const { getRoute } = useSystemRoutes(routeType)
    const { getHtmlHead } = useSystemHead(routeType)
    const { get: getProduct } = useItems({ itemType: itemTypes.product })
    const { getDependencyItem } = useDependencies()
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.document.id, scopeTypes.document.itemRelocate.id)

    const { setSystemLoading } = useAppContextFeatures();
    const { isLoading, create, update, get, filterOperatorTypes } = useDocuments({ 
        documentType: documentTypes.itemRelocate, 
        targetType: targetTypes.itemRelocate
    })

    const [actionConfirm, setActionConfirm] = useState(false)

    // const availableLocations = getAvailableLocations();

    const { list: getLocationRacks } = useLocations({ locationType: locationTypes.rack, targetType: targetTypes.rack });

    const [rackData, setRackData] = useState()

    const [savedValues, setSavedValues] = useState()

    const [dataItemUoms, setDataItemUoms] = useState([])

    const [preloadBatchData, setPreloadBatchData] = useState([])

    const loadData = async (id) => {

        setSystemLoading(true)

        try {

            const { data } = await get({ id })
            const { document, items } = data;

            const savedLocationId = document?.location_id;

            let dataRacks = []

            if (savedLocationId) {
                dataRacks = await fetchDataRacks(savedLocationId)
            }

            // console.log('data', data, dataRacks)

            let appendArray = []
            let selectBatchIds = []

            // create rows
            const rows = items.map((i, index) => {

                let itemId = i?.item_id
                let customBatchNo = i?.custom_batch_no
                let expiryDate = i?.expiry_date
                let relocateRackId = i?.relocate_rack_id
                let relocateSlotId = i?.relocate_slot_id
                let maxQty = 0;

                let rackId = i?.rack_id
                let rackName = i?.rack_ame
                let slotId = i?.slot_id
                let slotName = i?.slot_name

                // check the saved relocateRackId is type normal or reserve
                // const checkRack = dataRacks.filter(item => item.id === relocateRackId)

                // console.log('checkRack', checkRack)

                // const rowToType = checkRack.length > 0 ? checkRack[0].rack_type : 'normal'

                // console.log('checkRack[0].rack_type', checkRack[0].rack_type)

                const rowToType = rackTypes.normal
                const rowFromType = rackTypes.normal

                // update the state inventory batch 
                appendArray.push({
                    itemId,
                    selectedIndexNo: index
                })

                let batchObject = getBatchObject({
                    itemId,
                    batchNo: customBatchNo,
                    expiryDate,
                    rackId,
                    rackName,
                    slotId,
                    slotName,
                    maxQty
                })

                // console.log('b', batchObject)

                let { batchId, label } = batchObject

                selectBatchIds.push({
                    itemId,
                    batchId,
                    selectedIndexNo: index
                })

                return {
                    docItemId: i?.id,
                    itemId,
                    productId: i?.product_id,
                    name: i?.item_name,
                    code: i?.code,
                    description: i?.description,
                    isDefaultUom: false,
                    transformRatio: i?.transform_ratio,
                    price: i?.uom_price,
                    qty: {
                        value: parseFloat(i?.qty),
                        maxQty
                    },
                    uomName: i?.uom_name,
                    uomId: i?.uom_id,
                    inventoryCustomBatchNo: customBatchNo,
                    inventoryExpiryDate: expiryDate ? dayjs(expiryDate) : '',
                    rackId: relocateRackId,
                    slotId: relocateSlotId,
                    rowFromType,
                    rowToType
                }
            })

            if (appendArray.length) {
                // console.log('appendArray', appendArray)
                await appendMutipleInventoryBatch(appendArray)
            }

            setPreloadBatchData(selectBatchIds)

            setSavedValues({
                locationId: document?.location_id,
                locationName: document?.location_name,
                documentNumber: document?.doc_number,
                documentDate: dayjs(document?.doc_date),
                remark: document?.doc_remark ? document.doc_remark : "",
                rows,
                isConfirm: document?.is_confirm,
                confirmDateTime: document?.ax_updatedatetime
            })

        } catch (error) {
            promptMessage(false, `${error?.message}`)
        }

        setSystemLoading(false)

    }

    const onSubmit = async (currentValues) => {

        setSystemLoading(true)

        try {

            const document = {
                doc_date: currentValues.documentDate.format("YYYY-MM-DD"),
                doc_remark: currentValues.remark,
            }

            const status = {
                is_confirm: actionConfirm ? "1" : "0"
            }

            const props = {
                location_id: currentValues.locationId
            }

            let items = [];

            currentValues.rows.forEach((item, index) => {

                // get the saved inventory batched selection from hook state
                const selected = getSelectedInventoryBatch({ selectedIndexNo: index })

                items.push({
                    id: item?.itemId,
                    code: item?.code,
                    name: item?.name,
                    description: item?.description,
                    qty: item?.qty.value,
                    uom_lbl: item?.uomName,
                    uom: item?.uomId,
                    price: item?.price,
                    props: {
                        relocate_slot_id: item?.slotId
                    },
                    deductions: {
                        slot_id: selected?.slotId,
                        custom_batch_no: selected?.customBatchNo,
                        expiry_date: selected?.expiryDate
                    }
                })

            })

            let data = {
                document,
                status,
                props,
                items
            }

            const response = await update({ id, data });

            console.log('response update ', response)

            promptMessage(true, `${response?.message}`, response)

            const newItemRelocateDocumentId = response?.data?.document?.id

            if (actionConfirm) {

                let transformItems = [];

                const dependencies = [
                    getDependencyItem({
                        targetType: dependencyTargetTypes[dependencyModules.document].itemRelocate,
                        dependencyScope: dependencyModules.document,
                        dependencyType: dependencyTypes.reference,
                        targetId: newItemRelocateDocumentId
                    })
                ]

                currentValues.rows.forEach(i => {

                    // check the transform to default is enabled
                    if (i?.isAutoTransform === true) {

                        // getting the default uom 
                        let selectedProduct = dataItemUoms.filter(e1 => e1.product_id === i?.productId)
                        let defaultItem = selectedProduct.filter(e1 => e1.default_uom_item_id === e1.id)

                        if (defaultItem.length > 0) { // check for default uom exists

                            // const dependencies = [
                            //     {
                            //         scope: dependencyModules.document,
                            //         target: dependencyTargetTypes.delivery,
                            //         target_id: "915",
                            //         type: dependencyTypes.reference
                            //     }
                            // ]


                            let defaultItemSelected = defaultItem[0]

                            console.log('defaultItemSelected', defaultItem, defaultItemSelected)

                            let deductions = [];

                            let itemTransform = {
                                id: defaultItemSelected?.id,
                                code: defaultItemSelected?.code,
                                name: defaultItemSelected?.item_name,
                                description: defaultItemSelected?.description,
                                uom_lbl: defaultItemSelected?.uom_name,
                                uom: defaultItemSelected?.uom_id,
                                price: defaultItemSelected?.uom_price
                            }

                            let transformItem = {
                                ...itemTransform,
                                qty: parseFloat(i?.qty.value * i?.transformRatio),
                                addition: {
                                    slot_id: i?.slotId,
                                    custom_batch_no: i?.inventoryCustomBatchNo ? i.inventoryCustomBatchNo : "",
                                    expiry_date: i?.inventoryExpiryDate ? i.inventoryExpiryDate.format("YYYY-MM-DD") : ""
                                }
                            }

                            let itemDeduction = {
                                id: i?.itemId,
                                code: i?.code,
                                name: i?.name,
                                description: i?.description,
                                uom_lbl: i?.uomName,
                                uom: i?.uomId,
                                price: i?.price
                            }

                            // i?.inventory.forEach(e1 => {
                            deductions.push({
                                ...itemDeduction,
                                qty: parseFloat(i?.qty.value),
                                slot_id: i?.slotId,
                                custom_batch_no: i?.inventoryCustomBatchNo ? i.inventoryCustomBatchNo : "",
                                expiry_date: i?.inventoryExpiryDate ? i.inventoryExpiryDate.format("YYYY-MM-DD") : ""
                            })
                            // })

                            transformItems.push({
                                force_transform: 1, // always force
                                deductions,
                                transform_item: transformItem
                            })

                        }
                    }


                })


                let data2 = {
                    document,
                    props,
                    dependencies,
                    items: transformItems
                }

                // console.log('data2', data2)

                const responseTransform = await create({ data: data2, targetType: targetTypes.itemTransform });

                console.log('responseTransform', responseTransform)
            }


            navigate(getRoute("documents/itemRelocates"))


        } catch (error) {
            promptMessage(false, `Action Failed (${error?.message})`)
        }

        setSystemLoading(false)

    }

    const fetchDataRacks = async (locationId) => {

        if (!locationId) return false;

        setSystemLoading(true);

        try {

            const props = {
                limit: 10000,
                skip: 0,
                sortInfo: {
                    id: "rack_name",
                    dir: -1
                }
            }

            props.parentId = locationId
            props.locationType = locationTypes.rack;

            const { data } = await getLocationRacks(props)
            // console.log('warehouseRacks', warehouseRacks, params)

            // for(let i = 0; i < data.racks.length; i+=1){
            data.racks.map(item => {

                let b = item?.slots;

                let newSlots = [];

                if (b) {

                    Object.keys(b).map((item2, index2) => {
                        // console.log('value', item2)
                        newSlots.push({
                            id: item2,
                            name: b[item2]
                        })
                        return false;
                    })
                }

                item._slots = newSlots;

                return false;
            })

            // console.log(data.racks)

            setRackData(data.racks)

            return data.racks

        } catch (error) {

            promptMessage(false, `${error.message}`)
        }

        setSystemLoading(false)

        return false

    }

    const fetchProduct = async ({ productId, index }) => {

        setSystemLoading(true)

        try {

            let props = {
                id: productId,
                itemType: itemTypes.product
            }

            let { data } = await getProduct(props);

            console.log('data --> ', data.items)

            if (data?.items) {
                setDataItemUoms(
                    dataItemUoms.concat(data.items)
                )
            }

            setSystemLoading(false)

        } catch (error) {
            promptMessage(false, `${error.message}`)
        }

        setSystemLoading(false)

    }

    const formik = useFormik({
        initialValues: savedValues,
        validationSchema,
        onSubmit,
        enableReinitialize: true
    });

    const { handleSubmit, handleChange, values, errors, touched, setFieldValue, } = formik;

    const {
        isLoading: isLoadingInventoryBatches,
        skipBatchId,
        // skipIndexNoArray,
        dataInventoryBatches,
        resetDataInventoryBatches,
        getBatchObject,
        selectInventoryBatch,
        getInventoryBatchesByItemId,
        getSelectedInventoryBatch,
        appendInventoryBatch,
        appendMutipleInventoryBatch,
        removeAllSelectedIndexNo,
        RenderValueComponent,
        RenderSubHeaderComponent,
        RenderMenuItemComponent,
    } = useStateInventoryBatches({
        locationId: values?.locationId
    })

    useEffect(() => {

        loadData(id)

    }, [])


    useEffect(() => {

        preloadBatchData.forEach((e1, index) => {

            const selected = selectInventoryBatch({
                itemId: e1?.itemId,
                batchId: e1?.batchId,
                selectedIndexNo: e1?.selectedIndexNo
            })

            if (values) {

                // console.log('selected', selected)

                const { rackType } = selected

                setFieldValue(
                    `rows.${index}.qty.maxQty`,
                    parseFloat(selected?.totalRemainQty)
                )

                setFieldValue(
                    `rows.${index}.rowFromType`,
                    rackType === rackTypes.normal ? rackTypes.normal : rackTypes.reserve
                )
            }

        })

    }, [dataInventoryBatches])

    const getBreadcumbActionMenus = () => {

        let props = []

        // if (isPermissionAllow({ functionType: functionTypes.pageNew.id })) {
        //     props.push({
        //         displayText: "Load From ...",
        //         onClick: () => {

        //             // check the location is selected - valid
        //             if(validateLocationSelection() === false){
        //                 promptMessage(false, `Please select any location`)
        //                 return false;
        //             }

        //             // setOpenSearchDocuments(true)
        //             setSearchDocumentConfig(prev => ({...prev, show: true}))

        //             return true;
        //         }
        //     })
        // }

        return props
    }

    // able to filter out the inventory batches been selected even for the same uom id
    const getAvailableInventoryBatches = ({ index, itemId }) => {

        const selected = getInventoryBatchesByItemId({ itemId, selectedIndexNo: index })

        // get the row type of the state
        const rowFromType = values.rows[index].rowFromType

        if (!rowFromType) return []

        let data = selected.filter(i => i.batchId !== 'skip')

        // console.log('selected', data, rowFromType)

        // if the row type is normal
        if (rowFromType === rackTypes.normal) {
            data = data.filter(i => i.rackType !== rackTypes.reserve)
        }

        // if the row type is reserve
        if (rowFromType === rackTypes.reserve) {
            data = data.filter(i => i.rackType === rackTypes.reserve)
        }

        return data;
    }

    // const validateLocationSelection = () => {
    //     // return (selectLocationIds && selectLocationIds.length === 1)
    //     const selected = getLocationIds()
    //     return selected && selected.length === 1
    // }

    const checkIsAllowTransform = ({ itemValues }) => {

        // let selectedProduct = dataItemUoms.filter(item => item.product_id === productId)
        // let defaultItem = selectedProduct.filter(item => item.default_uom_item_id === itemId)

        // console.log('productId', productId, itemId, defaultItem)

        return itemValues.isDefaultUom === false

    }

    const handleAddItem = ({ rows, setFieldValue }) => {

        rows.push(initialRowValues);
        setFieldValue('rows', rows)

    }

    const handleRemoveItem = ({ rows, index, setFieldValue }) => {

        const currentLine = rows ? rows.length : 0;

        if (currentLine <= 1) {
            promptMessage(false, t(`itemsAtLeastHave1Row`))
            return false;
        }

        const newRows = rows.filter((i, ind) => ind !== index)

        // rows.remove(index);
        setFieldValue('rows', newRows)

        return true;

    }

    const getRacks = () => {

        return rackData
    }

    const getSlots = ({ rackId }) => {

        if (!rackId) return []
        if (!rackData) return []

        const rack = rackData.filter(item => item.id === rackId)

        return rack && rack.length ? rack[0]._slots : []
    }

    const RenderRackSelect = ({
        index,
        itemValues,
        itemErrors,
        itemTouched
    }) => {

        const allRacks = getRacks();

        if (!allRacks) return <></>

        let availableRacks = [];

        // check if the row to type
        if (itemValues.rowToType === rackTypes.normal) {
            availableRacks = allRacks.filter(i => i.rack_type !== rackTypes.reserve)
        } else {
            availableRacks = allRacks.filter(i => i.rack_type === rackTypes.reserve)
        }


        return (
            <FormControl
                margin="dense"
                fullWidth
                size="small"
                error={Boolean(itemTouched?.rackId) && Boolean(itemErrors?.rackId)}
            >
                <InputLabel id="rack-label">{t('rack')}</InputLabel>
                <Select
                    labelId="rack-label"
                    id="rack_id"
                    value={itemValues?.rackId}
                    name={`rackId`}
                    label={t("rack")}
                    margin="dense"
                    size="small"
                    onChange={(event) => {
                        setFieldValue(`rows.${index}.rackId`, event.target.value)
                    }}
                >
                    {
                        availableRacks.map((item, index) =>
                            <MenuItem key={index} value={item.id}>
                                {item.rack_name}
                            </MenuItem>
                        )
                    }
                </Select>
                <FormHelperText>
                    {itemTouched?.rackId && itemErrors?.rackId}
                </FormHelperText>
            </FormControl>
        )
    }

    const RenderSlotSelect = ({
        index,
        itemValues,
        itemErrors,
        itemTouched
    }) => {

        // if(!values.rackId) return <></>

        const items = getSlots({ rackId: itemValues?.rackId });

        return (
            <FormControl
                margin="dense"
                fullWidth
                size="small"
                error={Boolean(itemTouched?.slotId) && Boolean(itemErrors?.slotId)}
            >
                <InputLabel id="documentType">{t('slot')}</InputLabel>
                <Select
                    id="slotSelection"
                    value={itemValues?.slotId}
                    name={`slotId`}
                    label={t("slot")}
                    margin="dense"
                    size="small"
                    onChange={(event) => {
                        setFieldValue(`rows.${index}.slotId`, event.target.value)
                    }}
                >
                    {
                        items.map((item, index) => <MenuItem key={index} value={item.id}>{item.name}</MenuItem>)
                    }
                </Select>
                <FormHelperText>
                    {itemTouched?.slotId && itemErrors?.slotId}
                </FormHelperText>
            </FormControl>
        )

    }

    const RenderRowTypeButtons = ({
        actionType,
        index,
        itemValues,
        itemErrors,
        itemTouched
    }) => {
        return (
            <FormControl
                margin="dense"
                fullWidth
                size="small"
            // error={Boolean(itemErrors?.rowType)}
            >
                <ButtonGroup
                    variant="outlined"
                    aria-label="outlined button group"
                    // disabled={isLoadingInventoryBatches}
                    sx={{
                        // mt: 1
                    }}
                    size="small"
                // orientation="vertical"
                >
                    {
                        actionType === "from" ?
                            (
                                <>
                                    <Tooltip title={t(`relocateFromNormalRacks`)}>
                                        <Button
                                            fullWidth
                                            variant={itemValues?.rowFromType === rackTypes.normal ? 'contained' : 'outlined'}
                                            onClick={() => {
                                                setFieldValue(`rows.${index}.rowFromType`, rackTypes.normal)
                                                setFieldValue(`rows.${index}.qty`, { value: "0", maxQty: parseFloat(0) })
                                                removeAllSelectedIndexNo({ itemId: itemValues.itemId, selectedIndexNo: index })
                                            }}
                                        >
                                            {t('normal')}
                                        </Button>
                                    </Tooltip>
                                    <Tooltip title={t(`relocateFromReservedRacks`)}>
                                        <Button
                                            fullWidth
                                            variant={itemValues?.rowFromType === rackTypes.reserve ? 'contained' : 'outlined'}
                                            onClick={() => {
                                                setFieldValue(`rows.${index}.rowFromType`, rackTypes.reserve)
                                                setFieldValue(`rows.${index}.qty`, { value: "0", maxQty: parseFloat(0) })
                                                removeAllSelectedIndexNo({ itemId: itemValues.itemId, selectedIndexNo: index })
                                            }}
                                        >
                                            {t('reserved')}
                                        </Button>
                                    </Tooltip>
                                </>
                            )
                            :
                            (
                                <>
                                    <Tooltip title={t(`relocateFromNormalRacks`)}>
                                        <Button
                                            fullWidth
                                            variant={itemValues?.rowToType === rackTypes.normal ? 'contained' : 'outlined'}
                                            onClick={() => {
                                                setFieldValue(`rows.${index}.rowToType`, rackTypes.normal)
                                                setFieldValue(`rows.${index}.slotId`, '')
                                                setFieldValue(`rows.${index}.rackId`, '')
                                                // setFieldValue(`rows.${index}.qty`, { value: "0", maxQty: parseFloat(0) })
                                                // removeAllSelectedIndexNo({ itemId: itemValues.itemId, selectedIndexNo: index })
                                            }}
                                        >
                                            {t('normal')}
                                        </Button>
                                    </Tooltip>
                                    <Tooltip title={t(`relocateFromReservedRacks`)}>
                                        <Button
                                            fullWidth
                                            variant={itemValues?.rowToType === rackTypes.reserve ? 'contained' : 'outlined'}
                                            onClick={() => {
                                                setFieldValue(`rows.${index}.rowToType`, rackTypes.reserve)
                                                setFieldValue(`rows.${index}.slotId`, '')
                                                setFieldValue(`rows.${index}.rackId`, '')
                                                // setFieldValue(`rows.${index}.qty`, { value: "0", maxQty: parseFloat(0) })
                                                // removeAllSelectedIndexNo({ itemId: itemValues.itemId, selectedIndexNo: index })
                                            }}
                                        >
                                            {t('reserved')}
                                        </Button>
                                    </Tooltip>
                                </>
                            )
                    }

                </ButtonGroup>
                {/* <FormHelperText>
                    {
                        itemErrors?.rowType
                    }
                </FormHelperText> */}
                {/* <FormHelperText sx={{ textAlign: 'center' }}>
                    {
                        itemValues?.rowType === 'reserved' && `Relocate from Reserved Racks`
                    }
                    {
                        itemValues?.rowType === 'normal' &&`Relocate from Normal Racks`
                    }
                </FormHelperText> */}
            </FormControl>
        )
    }

    const RenderPreviewAutoTransform = ({ itemValues, index }) => {

        let itemValueQty = Number.isNaN(itemValues?.qty?.value) ? 0 : itemValues?.qty?.value

        if (dataItemUoms.length <= 0) return <></>
        if (itemValues?.isAutoTransform === false) return <></>
        if (parseFloat(itemValues?.qty?.value) <= 0) return <></>
        if (itemValueQty <= 0) return <></>

        let selectedProduct = dataItemUoms.filter(i => i.product_id === itemValues?.productId)
        let defaultItem = selectedProduct.filter(i => i.default_uom_item_id === i.id)

        let defaultUomName = ''
        let transformRatio = parseFloat(itemValues?.transformRatio)
        let autoTransformQty = 0
        let tooltipMessage = '';

        // console.log('defaultItem', itemValues, itemValues?.qty?.value)

        // getting the default item uom name
        if (defaultItem.length) {
            defaultUomName = defaultItem[0].uom_name
            autoTransformQty = itemValueQty * transformRatio
            tooltipMessage = `${parseFloat(itemValues?.qty?.value)} x ${transformRatio} = ${parseFloat(autoTransformQty)}`
        }

        const RenderPreviewItem = ({
            showNext = false,
            tooltipMessage = '',
            qty,
            uomName = ''
        }) => {
            return (
                <Box
                    display={"flex"}
                    flexDirection={"row"}
                    justifyContent={"center"}
                    alignItems={"center"}
                    textAlign={"center"}
                    sx={{
                        flex: 1,
                        // backgroundColor: 'yellow',
                        // mr: 1,
                        position: 'relative'
                    }}
                >
                    <Box
                        display={"flex"}
                        flexDirection={"column"}
                        justifyContent={"center"}
                        alignItems={"center"}
                        textAlign={"left"}
                    >
                        <Typography
                            sx={{
                                fontWeight: '800',
                                textAlign: 'center'
                            }}
                        >
                            {parseFloat(qty)}
                        </Typography>
                        <Tooltip title={tooltipMessage}>
                            <Box
                                display={"flex"}
                                flexDirection={"row"}
                                justifyContent={"center"}
                                alignItems={"center"}
                                textAlign={"center"}
                            >
                                <Typography
                                    sx={{
                                        fontSize: 13
                                    }}
                                >
                                    {uomName}
                                </Typography>
                                <CommonIcons name={icons.info} sx={{ width: 15, height: 15 }} />
                            </Box>
                        </Tooltip>
                    </Box>
                    {
                        (showNext === true) &&
                        <CommonIcons name={icons.chevronRight} sx={{ position: 'absolute', top: 13, right: 0 }} />
                    }
                </Box>
            )
        }

        return (

            <Box
                display={"flex"}
                flexDirection={"row"}
                justifyContent={"space-between"}
                alignItems={"center"}
                sx={{

                    backgroundColor: grey[100],
                    borderRadius: 1,
                    px: 1,
                    py: 1
                }}
            >
                <RenderPreviewItem
                    tooltipMessage={`Selected`}
                    qty={itemValueQty}
                    uomName={itemValues?.uomName}
                    showNext
                />

                <RenderPreviewItem
                    tooltipMessage={tooltipMessage}
                    qty={autoTransformQty}
                    uomName={defaultUomName}
                // showNext
                />

                {/* {JSON.stringify()} */}
            </Box>

        )
    }

    const RenderTransformToDefaultUom = ({ itemValues, index }) => {

        // if (itemValues?.isDefaultUom === true) return <></>

        if (
            checkIsAllowTransform({ itemValues }) === false
        ) return <></>

        // if (!itemValues?.productId) return <></>

        return (
            <Grid item md={12} xs={12} sm={12} textAlign={"center"}>

                {/* <FormGroup> */}
                <FormControlLabel
                    control={
                        <Checkbox
                            // defaultChecked
                            size="small"
                            value={1}
                            checked={
                                Boolean(itemValues.isAutoTransform)
                            }
                            onChange={(e) => {
                                let isCheck = e.target.checked

                                setFieldValue(
                                    `rows.${index}.isAutoTransform`,
                                    isCheck
                                )

                                fetchProduct({
                                    index,
                                    productId: itemValues?.productId
                                })

                            }}
                        />
                    }
                    label={
                        <Typography
                            sx={{
                                fontSize: 13
                            }}
                        >
                            {t('transformToDefaultUom')}
                        </Typography>
                    }
                />
                {/* </FormGroup> */}

                {
                    RenderPreviewAutoTransform({
                        itemValues,
                        index
                    })
                }

            </Grid>
        )
    }

    const RenderRows = () => {

        const rows = values?.rows;

        return (
            <Box
            >
                <Box
                >
                    {
                        rows && rows.length > 0
                        && rows.map((item, index) => {

                            const itemValues = item;
                            let itemTouched = touched?.rows
                            let itemErrors = errors?.rows
                            // const itemTouched = touched?.rows

                            if (itemTouched) {
                                itemTouched = (itemTouched[index] !== undefined) ? itemTouched[index] : {};
                            }

                            if (itemErrors) {
                                itemErrors = (itemErrors[index] !== undefined) ? itemErrors[index] : {};
                            }

                            return (

                                <Grid key={index} container spacing={1} sx={{ mb: 2 }}>
                                    {/* {JSON.stringify(itemValues)} */}
                                    <Grid item xs={12} sm={12} md={0.5} display={"flex"} flexDirection={"column"} justifyContent={"flex-start"} alignItems={"center"}>
                                        <IconButton
                                            aria-label="delete"
                                            onClick={() => handleRemoveItem({ rows: values.rows, index, setFieldValue })}
                                            sx={{
                                                mt: 1
                                            }}
                                        >
                                            <CommonIcons name={icons.remove} />
                                        </IconButton>
                                    </Grid>

                                    <Grid item xs={12} sm={12} md={2.5}>

                                        <SearchItems
                                            id={`rows.${index}.name`}
                                            handleOnCancel={() => { }}
                                            handleOnSearchChange={(event) => {
                                                setFieldValue(`rows.${index}.name`, `${event.target.value}`)
                                            }}
                                            handleOnSelect={({ id, item }) => {

                                                console.log('id', id, item)

                                                appendInventoryBatch({ itemId: item?.id, selectedIndexNo: index })

                                                setFieldValue(`rows.${index}.itemId`, item?.id)
                                                setFieldValue(`rows.${index}.productId`, item?.product_id)
                                                setFieldValue(`rows.${index}.transformRatio`, item?.transform_ratio)

                                                setFieldValue(`rows.${index}.name`, item?.item_name)
                                                setFieldValue(`rows.${index}.description`, item?.description)
                                                setFieldValue(`rows.${index}.code`, item?.code)
                                                setFieldValue(`rows.${index}.uomName`, item?.uom_name)
                                                setFieldValue(`rows.${index}.uomId`, item?.uom_id)
                                                setFieldValue(`rows.${index}.price`, item?.uom_price)
                                                setFieldValue(`rows.${index}.qty`, { value: "0", maxQty: parseFloat(0) })

                                                setFieldValue(
                                                    `rows.${index}.isDefaultUom`,
                                                    item?.id === item?.default_uom_item_id
                                                )

                                            }}
                                            textProps={{
                                                disabled: true,
                                                value: itemValues?.name ? itemValues.name : "",
                                                error: Boolean(itemErrors?.name),
                                                helperText: itemErrors?.name
                                            }}
                                        />

                                        {
                                            (itemValues?.itemId) &&
                                            <>
                                                <Chip
                                                    label={`${itemValues.code} (${itemValues.uomName})`}
                                                    variant="outlined"
                                                    size="small"
                                                />
                                                {
                                                    itemValues.isDefaultUom &&
                                                    <Chip
                                                        label={t(`defaultUom`)}
                                                        variant="outlined"
                                                        size="small"
                                                    />
                                                }
                                            </>
                                        }

                                    </Grid>

                                    <Grid item xs={12} sm={12} md={5}>

                                        <Card
                                            sx={{
                                                px: 1,
                                                py: 1,
                                            }}
                                        >

                                            <Grid container spacing={0}>

                                                <Grid item xs={6} sm={6} md={4} alignItems={"center"} justifyItems={"center"} display={"flex"}>
                                                    <Chip
                                                        label={t("from")}
                                                        size="small"
                                                        variant="contained"
                                                        // color={"warning"}
                                                        sx={{
                                                            backgroundColor: orange[400],
                                                            fontWeight: 700
                                                            // mt: -3,
                                                            // ml: -2,
                                                            // pl: 1
                                                        }}
                                                    />
                                                </Grid>

                                                <Grid
                                                    item
                                                    xs={6} sm={6} md={8}
                                                    textAlign={"right"}
                                                >
                                                    <Box
                                                        sx={{
                                                            // mt: -2,
                                                            // mr: -1,
                                                            zIndex: 999
                                                            // ml: -2,
                                                            // pl: 1
                                                        }}
                                                    >
                                                        {
                                                            RenderRowTypeButtons({
                                                                actionType: "from",
                                                                index,
                                                                itemValues,
                                                                itemErrors,
                                                                itemTouched
                                                            })
                                                        }
                                                    </Box>
                                                </Grid>

                                            </Grid>

                                            <Grid container spacing={1}>

                                                {/* inventoryBatches */}
                                                <Grid item xs={6} sm={6} md={8}>

                                                    {
                                                        isLoadingInventoryBatches ?
                                                            (
                                                                <TextField
                                                                    margin="dense"
                                                                    size="small"
                                                                    fullWidth
                                                                    placeholder="Loading..."
                                                                    type="text"
                                                                    variant="outlined"
                                                                />
                                                            )
                                                            :
                                                            (
                                                                <FormControl
                                                                    margin="dense"
                                                                    fullWidth
                                                                    size="small"
                                                                    error={Boolean(itemErrors?.inventoryBatchId)}
                                                                >
                                                                    <InputLabel id="inventoryBatchId">{t('inventory')}</InputLabel>
                                                                    <Select
                                                                        disabled={
                                                                            !(itemValues?.itemId)
                                                                        }
                                                                        labelId="inventoryBatchId"
                                                                        label={t('inventory')}
                                                                        name={`rows.${index}.inventoryBatchId`}
                                                                        // onChange={handleChange}
                                                                        onChange={(event) => {

                                                                            // console.log('event', event.target.value)

                                                                            let batchId = event.target.value

                                                                            const selectedBatch = selectInventoryBatch({
                                                                                itemId: itemValues.itemId,
                                                                                batchId,
                                                                                selectedIndexNo: index
                                                                            })

                                                                            setFieldValue(`rows.${index}.inventoryBatchId`, batchId)
                                                                            setFieldValue(`rows.${index}.inventoryCustomBatchNo`, selectedBatch?.customBatchNo)
                                                                            setFieldValue(`rows.${index}.inventoryExpiryDate`, selectedBatch?.expiryDate)

                                                                            setFieldValue(
                                                                                `rows.${index}.qty`,
                                                                                {
                                                                                    value: "0",
                                                                                    maxQty: parseFloat(selectedBatch?.totalRemainQty),
                                                                                }
                                                                            )

                                                                        }}
                                                                        renderValue={(value) => {

                                                                            const a = getSelectedInventoryBatch({ selectedIndexNo: index })

                                                                            return (
                                                                                <RenderValueComponent item={a} />
                                                                            )
                                                                        }}
                                                                        value={
                                                                            getSelectedInventoryBatch({ selectedIndexNo: index })?.batchId ?
                                                                                getSelectedInventoryBatch({ selectedIndexNo: index }).batchId
                                                                                :
                                                                                ""
                                                                        }
                                                                        sx={{
                                                                            textAlign: 'left',
                                                                        }}
                                                                        MenuProps={{
                                                                            MenuListProps: {
                                                                                sx: {
                                                                                    py: 0,
                                                                                },
                                                                            }
                                                                        }}
                                                                    >
                                                                        <RenderSubHeaderComponent />
                                                                        {
                                                                            getAvailableInventoryBatches({ index, itemValues, itemId: itemValues.itemId }).map((i, index2) => {
                                                                                return (
                                                                                    // <RenderMenuItemComponent
                                                                                    //     key={index2}
                                                                                    //     index={index2}
                                                                                    //     item={i}
                                                                                    // />
                                                                                    RenderMenuItemComponent({
                                                                                        key: index2,
                                                                                        index: index2,
                                                                                        item: i,
                                                                                        style: {
                                                                                            width: 500,
                                                                                        }
                                                                                    })
                                                                                )
                                                                            })
                                                                        }
                                                                    </Select>
                                                                    <FormHelperText>
                                                                        {
                                                                            itemErrors?.inventoryBatchId ?
                                                                                itemErrors?.inventoryBatchId
                                                                                :
                                                                                getSelectedInventoryBatch({ selectedIndexNo: index })?.batchId ?
                                                                                    getSelectedInventoryBatch({ selectedIndexNo: index }).label
                                                                                    :
                                                                                    ""
                                                                        }
                                                                    </FormHelperText>
                                                                </FormControl>
                                                            )
                                                    }

                                                </Grid>

                                                <Grid item xs={6} sm={6} md={4}>
                                                    <TextField
                                                        disabled={
                                                            itemValues?.inventoryBatchId ? Boolean(false) : Boolean(true)
                                                        }
                                                        margin="dense"
                                                        size="small"
                                                        fullWidth
                                                        name={`rows.${index}.qty`}
                                                        label={`Qty ${itemValues?.uomName ? "(".concat(itemValues.uomName).concat(")") : ""}`}
                                                        type="text"
                                                        variant="outlined"
                                                        value={
                                                            itemValues?.qty?.value ? itemValues.qty.value : ""
                                                        }
                                                        onChange={(event) => {
                                                            setFieldValue(
                                                                `rows.${index}.qty`,
                                                                {
                                                                    value: event.target.value,
                                                                    maxQty: parseFloat(itemValues.qty.maxQty),
                                                                    // skipStockPost: itemValues.qty.skipStockPost
                                                                }
                                                            )
                                                        }}
                                                        onFocus={event => {
                                                            event.target.select();
                                                        }}
                                                        InputProps={{
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    {
                                                                        `/ ${itemValues?.qty?.maxQty}`
                                                                    }
                                                                </InputAdornment>
                                                            )
                                                        }}
                                                        error={Boolean(itemErrors?.qty?.value)}
                                                        helperText={itemErrors?.qty?.value}
                                                    />
                                                </Grid>

                                            </Grid>
                                        </Card>

                                    </Grid>

                                    <Grid item xs={12} sm={12} md={4}>

                                        <Card
                                            sx={{
                                                px: 1,
                                                py: 1,
                                            }}
                                        >

                                            <Grid container spacing={0}>

                                                <Grid item xs={6} sm={6} md={4} alignItems={"center"} justifyItems={"center"} display={"flex"}>
                                                    <Chip
                                                        label={t("to")}
                                                        size="small"
                                                        variant="contained"
                                                        // color={"primary"}
                                                        sx={{
                                                            backgroundColor: orange[400],
                                                            fontWeight: 700
                                                            // mt: -3,
                                                            // ml: -2,
                                                            // pl: 1
                                                        }}
                                                    />
                                                </Grid>

                                                <Grid
                                                    item
                                                    xs={6} sm={6} md={8}
                                                    textAlign={"right"}
                                                >
                                                    <Box
                                                        sx={{
                                                            // mt: -2,
                                                            // mr: -1,
                                                            zIndex: 999
                                                            // ml: -2,
                                                            // pl: 1
                                                        }}
                                                    >
                                                        {
                                                            RenderRowTypeButtons({
                                                                actionType: "to",
                                                                index,
                                                                itemValues,
                                                                itemErrors,
                                                                itemTouched
                                                            })
                                                        }
                                                    </Box>
                                                </Grid>

                                            </Grid>

                                            <Grid container spacing={1}>

                                                <Grid item md={6} xs={6} sm={6}>
                                                    {
                                                        RenderRackSelect({
                                                            index,
                                                            itemValues,
                                                            itemErrors,
                                                            itemTouched
                                                        })
                                                    }
                                                </Grid>

                                                <Grid item md={6} xs={6} sm={6}>
                                                    {
                                                        RenderSlotSelect({
                                                            index,
                                                            itemValues,
                                                            itemErrors,
                                                            itemTouched
                                                        })
                                                    }
                                                </Grid>

                                                {
                                                    RenderTransformToDefaultUom({
                                                        itemValues,
                                                        index
                                                    })
                                                }

                                            </Grid>

                                        </Card>

                                    </Grid>


                                </Grid>
                            )
                        })
                    }
                </Box>

                <Grid item xs={12}>
                    <Divider sx={{ mt: 1, mb: 0 }} />
                </Grid>

                {
                    RenderSummaryRow({ values, errors, touched, handleChange, setFieldValue })
                }

            </Box>
        )
    }

    const RenderSummaryRow = () => {
        return (
            <Grid item xs={12} sm={12} md={12}>

                <Grid container spacing={0.5}>

                    <Grid item xs={12} sm={12} md={4}>

                        <Button
                            variant="outlined"
                            sx={{ mt: 2 }}
                            fullWidth
                            startIcon={<CommonIcons name={icons.add} />}
                            onClick={() => handleAddItem({ rows: values.rows, setFieldValue })}
                        >
                            {t('addItem')}
                        </Button>

                    </Grid>

                    <Grid item xs={12} sm={12} md={5}>
                        <></>
                    </Grid>

                    {/* <Grid item xs={12} sm={12} md={3}>
                        <TextField
                            inputProps={{
                                style: {
                                    textAlign: "right"
                                }
                            }}

                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <CommonIcons name={icons.discount} />
                                    </InputAdornment>
                                ),
                            }}
                            
                            margin="dense"
                            size="small"
                            fullWidth
                            name={"discount"}
                            label="Discount"
                            type="text"                                         
                            variant="outlined"
                            value={values.discount}
                            onChange={(event) => {
                                setFieldValue(`discount`, event.target.value);
                                // handleDisplaySummaryChange({ discount: event.target.value});
                            }}
                            error={touched.discount && Boolean(errors.discount)}
                            helperText={touched.discount && errors.discount}
                        />
                    </Grid> */}

                </Grid>

                <Grid container spacing={0.5}>

                    <Grid item xs={12} sm={12} md={9}>
                        <></>
                    </Grid>

                    {/* <Grid item xs={12} sm={12} md={1}>
                        <Typography sx={{ mt: 2, mp: 2}}>
                        Discount
                        </Typography>
                    </Grid> */}

                    {/* <Grid item xs={12} sm={12} md={3}>
                        <TextField
                            inputProps={{
                                style: {
                                    textAlign: "right"
                                }
                            }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Typography
                                            sx={{
                                                fontSize: '1.5rem',
                                                fontWeight: 600
                                            }}
                                        >
                                            =
                                        </Typography>
                                    </InputAdornment>
                                ),
                            }}
                            margin="dense"
                            size="small"
                            disabled
                            fullWidth
                            name={"totalamount"}
                            label="Total Amount"
                            type="text"                                         
                            variant="outlined"
                            value={values?.totalamount? values.totalamount : "0.00"}
                        />
                    </Grid> */}

                </Grid>

            </Grid>
        )
    }

    const RenderFormLocation = () => {
        return (
            <StyledCard>
                <Grid container spacing={0.5}>
                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                        <CommonSectionHeader
                            title={t(`location`)}
                            subTitle={t(`relatedWarehouseLocationToProcess`)}
                        />

                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                        <TextField
                            disabled
                            margin="dense"
                            size="small"
                            fullWidth
                            name={"locationId"}
                            label={t("location")}
                            type="text"
                            variant="outlined"
                            value={values.locationName}
                            error={touched.locationId && Boolean(errors.locationId)}
                            helperText={touched.locationId && errors.locationId}
                        />
                    </Grid>
                    {/* <Grid item md={1.5}>
                        <IconButton
                            color="primary"
                            sx={{
                                // pt: 0
                            }}
                            onClick={() => {
                                setLocationIds([])
                            }}
                        >
                            <StyledIcon
                                sx={{
                                    width: 25,
                                    height: 25,
                                    m: 0,
                                    p: 0
                                }}
                            >
                                <CommonIcons name={icons.edit} />
                            </StyledIcon>
                        </IconButton>
                    </Grid> */}

                </Grid>
            </StyledCard>
        )
    }

    const RenderFormDocument = () => {
        return (
            <StyledCard>
                <Grid container spacing={0.5}>
                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                        <CommonSectionHeader
                            title={t(`document`)}
                            subTitle={t(`basicInformationAboutTheDocument`)}
                        />

                    </Grid>
                    <Grid item xs={12} sm={12} md={12} sx={{ mt: 2 }}>
                        <Grid container spacing={0.5}>

                            <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                                <DatePickerComponent
                                    config={{
                                        name: "documentDate",
                                        label: t("documentDate")
                                    }}
                                    formik={{
                                        values,
                                        errors,
                                        touched,
                                        handleChange,
                                        setFieldValue
                                    }}
                                />

                            </Grid>

                            <Grid item xs={12} sm={12} md={12}>
                                <TextField
                                    margin="dense"
                                    size="small"
                                    fullWidth
                                    name={"remark"}
                                    label={t("remark")}
                                    type="text"
                                    variant="outlined"
                                    multiline
                                    rows={3}
                                    value={values.remark}
                                    onChange={handleChange}
                                    error={touched.remark && Boolean(errors.remark)}
                                    helperText={touched.remark && errors.remark}
                                />
                            </Grid>

                        </Grid>
                    </Grid>
                </Grid>
            </StyledCard>
        )
    }

    const RenderForm = () => {

        if (!values) return <></>

        return (
            <form onSubmit={handleSubmit}>
                <Grid container spacing={1}>

                    <Grid item xs={12} sm={12} md={6} textAlign={"left"}>
                        {
                            RenderFormDocument()
                        }
                    </Grid>


                    <Grid item xs={12} sm={12} md={6} textAlign={"left"}>

                        {
                            RenderFormLocation()
                        }

                    </Grid>

                </Grid>
                {/* {JSON.stringify(errors)} */}
                <StyledCard sx={{ mt: 1 }}>
                    <Grid container rowSpacing={0}>
                        <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                            <CommonSectionHeader
                                title={t(`items`)}
                                subTitle={t(`detailInformationAboutTheItemsInvolved`)}
                            />

                        </Grid>

                        <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                            {
                                RenderRows()
                            }

                            {/* <FieldArray
                                name="rows"
                                render={(arrayHelpers) => {
                                    
                                    return RenderRow({ values, errors, touched, handleChange, setFieldValue, arrayHelpers})
                                
                                }}
                            /> */}
                        </Grid>

                    </Grid>
                </StyledCard>
                <Grid container spacing={1} sx={{ pl: 2, pr: 2, mt: 2 }}>
                    <Grid item md={12} textAlign={"right"}>
                        {
                            values?.isConfirm === "1" ?
                                (
                                    <Chip
                                        label={`${t('confirmedAt')} ${values?.confirmDateTime}`}
                                        color={"warning"}
                                        variant="contained"
                                    />
                                )
                                :
                                (
                                    <>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={actionConfirm}
                                                    onChange={() => { setActionConfirm(!actionConfirm) }}
                                                    name="actionConfirm"
                                                />
                                            }
                                            label={t("markAsConfirm")}
                                        />
                                        <LoadingButton
                                            type="submit"
                                            // fullWidth
                                            variant="contained"

                                            loading={isLoading}
                                        >
                                            {
                                                actionConfirm ? t(`yesIveConfirmed`) : t(`saveChanges`)
                                            }
                                        </LoadingButton>
                                    </>
                                )
                        }
                    </Grid>
                </Grid>
            </form>
        )
    }

    // const RenderAll = () => {
    //     return validateLocationSelection() ?
    //         (
    //             RenderForm()
    //         )
    //         :
    //         (
    //             <LocationSelector
    //                 config={{
    //                     title: "Select Only (1) Location",
    //                     description: "You have to select anyone of the warehouse location to proceed"
    //                 }}
    //                 maxSelect={1}
    //                 handleOnNext={({ selected }) => {

    //                     // console.log('selected', selected)

    //                     setLocationIds([selected[0].id])
    //                     setFieldValue(`locationId`, selected[0].id)
    //                     setFieldValue(`locationName`, selected[0].location_name)

    //                 }}
    //             />
    //         )
    // }

    return (
        <Box>
            {
                getHtmlHead({ routeType, title: headTitles.updateItemRelocate })
            }

            {/* <Typography sx={{ fontSize: 11 }}>
                {JSON.stringify(dataInventoryBatches)}
            </Typography> */}

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={t("updateItemRelocate")}
                actionMenus={
                    getBreadcumbActionMenus()
                }
                breadcrumbs={[
                    {
                        displayText: t("itemRelocates"),
                        props: {
                            href: getRoute('documents/itemRelocates')
                        }
                    },
                    {
                        displayText: t("updateItemRelocate"),
                        props: {
                            color: 'secondary.main',
                        }
                    },
                ]}
            />

            {
                isPermissionAllow({ functionType: functionTypes.pageUpdate.id }) ?
                    RenderForm()
                    :
                    (
                        <CommonRestricted />
                    )
            }

        </Box>
    )
}